import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Header, Filter } from "./component";
import { Tab, Nav } from "react-bootstrap";
import { TaskViewTab, UserViewTab, SpecialInstTab } from "./Tabs";
import { AddTaskModal, TaskFilter } from "./Tabs/TaskViewTab/components";
import { AddUserModal, UserFilter } from "./Tabs/UserViewTab/components";
import { useNavigate } from "react-router-dom";
import { isEmpty, filter } from "lodash";
import { AddUpdateTask } from "pages/TimeSheetManage/Task/component";
import AccessRights from "utils/AccessRights";

const View = () => {
  const navigate = useNavigate();

  const programState = useSelector((state) => state.programSetupState);
  const session = useSelector((s) => s.session);

  const task_per = filter(session.user_permissions_raw, function(item){
    if(!isEmpty(item)){
      return item.object_code === 'task';
    }
  });
  
  const object_viewed_id = session?.current_page_permissions?.object_id || "";

  const [programRecord, setProgramRecord] = useState(programState.programSetupRecord || {});
  const [activeKey, setActiveKey] = useState("home");
  const [showTaskModal, setShowTaskModal] = useState(false);
  const [showNewTaskModal, setShowNewTaskModal] = useState(false);
  const [showUserModal, setShowUserModal] = useState(false);

  const [taskExtraFiltersState, setTaskExtraFiltersState] = useState({
    values: {},
  });

  const [userExtraFiltersState, setUserExtraFiltersState] = useState({
    values: {},
  });


  useEffect(() => {
    if (programState.redirectToList) {
      navigate("/programs-setup");
    }
  }, [programState.redirectToList]);

  useEffect(() => {
    if (!programState.showSetupForm) {
      navigate("/programs-setup");
    }
  }, [programState.showSetupForm]);

  useEffect(() => {
    if (!isEmpty(programState.programSetupRecord)) {
      setProgramRecord(programState.programSetupRecord);
    }
    else{
      navigate("/programs-setup");
    }
  }, [programState.programSetupRecord]);

  const handleOpenTaskModal = () => {
    setShowTaskModal(true);
  };

  const handleCloseTaskModal = () => {
    setShowTaskModal(false);
  };

  const handleOpenNewTaskModal = () => {
    handleCloseTaskModal();
    setShowNewTaskModal(true);
  };

  const handleCloseNewTaskModal = () => {
    setShowNewTaskModal(false);

    setTimeout(function() {  
      handleOpenTaskModal();
    }, 3000);
    
  }

  const handleOpenUserModal = () => {
    setShowUserModal(true);
  };

  const handleCloseUserModal = () => {
    setShowUserModal(false);
  };

  

  return (
    <div className="wrapper-div">
      <Header />
      <div className="p-4">
        <div className="view-container">
          <h1 className="font-16 font-weight-medium p-3 mb-0 pb-0">
            {programRecord.program_name || programRecord.name || ""}
         </h1>
          <Tab.Container activeKey={activeKey} onSelect={(k) => setActiveKey(k)}>
            <div>
              {/* Header row: nav (tabs) on left + button on right */}
              <div className="d-flex justify-content-between align-items-center mb-3 p-3">
                <Nav
                  variant="tabs"
                  activeKey={activeKey}
                  onSelect={(k) => setActiveKey(k)}
                  className="flex-row"
                >
                  <Nav.Item>
                    <Nav.Link eventKey="home">Tasks</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="profile">Users</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="contact">Special Instructions</Nav.Link>
                  </Nav.Item>
                </Nav>

                {/* ✅ Right Side Buttons */}
                <div className="d-flex align-items-center gap-3">
                  {/* Show Filter only for Tasks & Users */}

                  {activeKey === "home" && (
                    <>
                      {/* <TaskFilter  object_viewed_id={object_viewed_id} programId={programRecord.id} taskExtraFiltersState={taskExtraFiltersState} setTaskExtraFiltersState={setTaskExtraFiltersState} /> */}
                      <button
                        className="add-new-btn d-flex align-items-center"
                        type="button"
                        onClick={handleOpenTaskModal}
                      >
                        <img
                          className="me-2 add-user-icon"
                          alt="Add Task"
                          src="/assets/images/bind-icon.svg"
                        />
                        Bind Task
                      </button>
                    </>
                  )}

                  {activeKey === "profile" && (
                    <>
                      {/* <UserFilter object_viewed_id={object_viewed_id} programId={programRecord.id} userExtraFiltersState={userExtraFiltersState} setUserExtraFiltersState={setUserExtraFiltersState} /> */}
                      <button
                        className="add-new-btn d-flex align-items-center"
                        type="button"
                        onClick={handleOpenUserModal}
                      >
                        <img
                          className="me-2 add-user-icon"
                          alt="Add User"
                          src="/assets/images/bind-icon.svg"
                        />
                        Bind User
                      </button>
                    </>  
                  )}
                </div>
              </div>

              {/* Content row: full width under the header */}
              <div className="mt-3">
                <Tab.Content>
                  <Tab.Pane eventKey="home">
                    <TaskViewTab programId={programRecord.id} taskExtraFiltersState={taskExtraFiltersState} setTaskExtraFiltersState={setTaskExtraFiltersState} />
                  </Tab.Pane>

                  <Tab.Pane eventKey="profile">
                    <UserViewTab programId={programRecord.id} userExtraFiltersState={userExtraFiltersState} setUserExtraFiltersState={setUserExtraFiltersState} />
                  </Tab.Pane>

                  <Tab.Pane eventKey="contact">
                    <SpecialInstTab programDetails={programRecord}/>
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </div>
          </Tab.Container>
        </div>
      </div>
      <AddTaskModal
        show={showTaskModal}
        handleClose={handleCloseTaskModal}
        programId={programRecord.id}
        handleOpenNewTaskModal={handleOpenNewTaskModal}
      />

      {!isEmpty(task_per) && AccessRights(task_per[0], 'add') ?
        <AddUpdateTask 
          show={showNewTaskModal}
          onHide={handleCloseNewTaskModal}
          isEdit={false}
          object_viewed_id={task_per[0]['object_id']}
        />
      :''}

      <AddUserModal
        show={showUserModal}
        handleClose={handleCloseUserModal}
        programId={programRecord.id}
      />
    </div>
  );
};

export default View;
